import { Pipe, PipeTransform } from '@angular/core';
import { formatNumber } from 'devextreme/localization';

@Pipe({
  name: 'formatNumber',
  standalone: true,
})
export class SiaFormatNumberPipe implements PipeTransform {
  transform(
    numberToFormat: number | undefined | string | null,
    format: string | undefined,
  ): string {
    if (typeof numberToFormat === 'string' && !isNumeric(numberToFormat)) {
      return numberToFormat;
    }
    return formatNumber(
      Number(numberToFormat) ?? 0,
      format ?? '###,###,###.##',
    );
  }
}
function isNumeric(str: string) {
  if (typeof str !== 'string') return false;
  if (str.trim() === '') return false;

  const n = Number(str);
  return Number.isFinite(n);
}
